// @ngInject
function stateConfig($stateProvider) {

    $stateProvider.state('product.maingroups.new', {
        url: '/new',
        views: {
            "wideColumnView@product": {
                templateUrl: 'main/product/maingroups/maingroup/maingroup.tpl.html',
                controller: 'MainGroupController as vm'
            }
        },
        resolve: {
            mainGroup: function () {
                return {
                    attributeVisibility: {
                        intrastat: 'visible',
                        meursing: 'visible',
                        productHeight: 'visible',
                        productLength: 'visible',
                        productWeight: 'visible',
                        productWidth: 'visible',
                        storageLocation: 'visible'
                    },
                    brands: []
                };
            },
            brands: brandsResolver,
            isNewMainGroup: function () { return true; },
            departments: departmentsResolver,
            tenantConfig: tenantConfigResolver,
            variants: variantsResolver,
            variantGroups: variantGroupsResolver,
            vats: vatsResolver,
            intrastats: intrastatResolver,
            subCategories: subCategoriesResolver,
            salesChannels: salesChannelResolver,
            accounts: accountsResolver,
            businessAreas: businessAreasReasolver
        }
    });

    $stateProvider.state('product.maingroups.maingroup', {
        url: '/{mainGroupId}',
        views: {
            "wideColumnView@product": {
                templateUrl: 'main/product/maingroups/maingroup/maingroup.tpl.html',
                controller: 'MainGroupController as vm'
            }
        },
        resolve: {
            mainGroup: mainGroupResolver,
            brands: brandsResolver,
            isNewMainGroup: function () { return false; },
            departments: departmentsResolver,
            tenantConfig: tenantConfigResolver,
            variants: variantsResolver,
            variantGroups: variantGroupsResolver,
            vats: vatsResolver,
            intrastats: intrastatResolver,
            subCategories: subCategoriesResolver,
            salesChannels: salesChannelResolver,
            accounts: accountsResolver,
            businessAreas: businessAreasReasolver
        }
    });
}

// @ngInject
function businessAreasReasolver(MaingroupsApiService) {
    return MaingroupsApiService.getBusinessAreas();
}

// @ngInject
function intrastatResolver(MaingroupsApiService) {
    return MaingroupsApiService.getIntrastats();
}
// @ngInject
function variantGroupsResolver(MaingroupsApiService) {
    return MaingroupsApiService.getVariantGroups();
}

// @ngInject
function vatsResolver(VatsApiService) {
    return VatsApiService.getVats();
}

// @ngInject
function variantsResolver(MaingroupsApiService) {
    return MaingroupsApiService.getVariants();
}

// @ngInject
function mainGroupResolver($stateParams, MaingroupsApiService) {
    return MaingroupsApiService.getMainGroup($stateParams.mainGroupId);
}

// @ngInject
function brandsResolver(MaingroupsApiService) {
    return MaingroupsApiService.getBrands();
}

// @ngInject
function departmentsResolver(MaingroupsApiService) {
    return MaingroupsApiService.getDepartments();
}

// @ngInject
function tenantConfigResolver(MaingroupsApiService) {
    return MaingroupsApiService.getTenantConfig();
}

//@ngInject
function subCategoriesResolver(MaingroupsApiService) {
    return MaingroupsApiService.getSubCategories();
}

//@ngInject
function salesChannelResolver(MaingroupsApiService) {
    return MaingroupsApiService.getSalesChannels();
}

// @ngInject
function accountsResolver(AccountsApiService) {
    return AccountsApiService.getAccounts();
}

// @ngInject
function MainGroupController($state, mainGroup, brands, loadSpinnerService, MaingroupsApiService, isNewMainGroup, departments, tenantConfig, variants, vats, variantGroups, intrastats, subCategories, salesChannels, accounts, businessAreas, $translate) {
    var vm = this;

    var mainGroupCopy = {};

    vm.mainGroup = mainGroup;
    vm.articleCollectionTypes = [
        { id: 0, description: $translate.instant('common.visible'), value:'visible' },
        { id: 1, description: $translate.instant('common.hidden'), value:'hidden' }
    ];
    vm.attributeVisibility = {
        intrastat: _.find(vm.articleCollectionTypes, function(t) { return t.value === vm.mainGroup.attributeVisibility.intrastat; }),
        meursing: _.find(vm.articleCollectionTypes, function(t) { return t.value === vm.mainGroup.attributeVisibility.meursing; }),
        productHeight: _.find(vm.articleCollectionTypes, function(t) { return t.value === vm.mainGroup.attributeVisibility.productHeight; }),
        productLength: _.find(vm.articleCollectionTypes, function(t) { return t.value === vm.mainGroup.attributeVisibility.productLength; }),
        productWeight: _.find(vm.articleCollectionTypes, function(t) { return t.value === vm.mainGroup.attributeVisibility.productWeight; }),
        productWidth: _.find(vm.articleCollectionTypes, function(t) { return t.value === vm.mainGroup.attributeVisibility.productWidth; }),
        storageLocation: _.find(vm.articleCollectionTypes, function(t) { return t.value === vm.mainGroup.attributeVisibility.storageLocation; })
    };
    vm.brands = [];
    vm.selectedBrands = [];
    vm.departments = departments;
    vm.variants = variants;
    vm.variantGroups = variantGroups;
    vm.vats = vats;

    vm.intrastats = intrastats;
    vm.subCategories = subCategories;
    vm.salesChannels = salesChannels;
    vm.accounts = accounts;
    vm.businessAreas = businessAreas;

    vm.addBrands = addBrands;
    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveMainGroup = saveMainGroup;

    vm.isNewMainGroup = isNewMainGroup;
    vm.isEditing = vm.isNewMainGroup;

    vm.tenantConfig = tenantConfig;
    vm.isVatValid = false;
    vm.isMainGroupVatValid = isMainGroupVatValid;
    vm.isMainGroupCodeValid = isMainGroupCodeValid;
    vm.isMainGroupDescriptionValid = isMainGroupDescriptionValid;
    vm.isAllInformationValid = isAllInformationValid;
    vm.filterVariant1 = filterVariant1;
    vm.preferredVariantGroups2 = [];
    vm.toggleDisplayForm = toggleDisplayForm;

    activate();


    function activate() {
        prepareData();
        if (vm.isNewMainGroup) {
            vm.mainGroup = {};
            vm.mainGroup['isVariant'] = true;
            vm.mainGroup['department'] = vm.departments[0];

            if (!vm.mainGroup.variant1) {
                vm.mainGroup.variant1 = _.find(vm.variants, { 'id': vm.tenantConfig.variant1 });
            }
            if (!vm.mainGroup.variant2) {
                vm.mainGroup.variant2 = _.find(vm.variants, { 'id': vm.tenantConfig.variant2 });
            }

        }
        vm.preferredVariantGroups2 = _.filter(vm.variantGroups, { variant: { id: vm.mainGroup.variant2.id}});
    }

    function addBrands() {
        var mainGroups = [vm.mainGroup];
        var brands = vm.selectedBrands;

        loadSpinnerService.start('mainSpinner');
        MaingroupsApiService.createItemGroups({ mainGroups: mainGroups, brands: brands }).then(function () {
            MaingroupsApiService.getMainGroup(vm.mainGroup.id).then(function (response) {
                vm.mainGroup = response;
                prepareData();
                vm.selectedBrands = [];
            }, function (error) {
                console.log(error);
            });
        }, function (error) {
            console.log(error);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function filterVariant1() {
        return function (item) {
            return item.id !== vm.mainGroup.variant2.id;
        };
    }

    function toggleDisplayForm(itemGroup) {
        if (!itemGroup.showEditForm) { itemGroup.showEditForm = false; }
        itemGroup.showEditForm = !itemGroup.showEditForm;
    }

    function enableEditing() {
        mainGroupCopy = angular.copy(vm.mainGroup);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.mainGroup = mainGroupCopy;
        vm.isEditing = false;
        vm.selectedBrands = [];
    }

    function saveMainGroup() {
        if (vm.isNewMainGroup) {
            saveNewMainGroup();
        } else {
            updateMainGroup();
        }
    }

    function saveNewMainGroup() {
        loadSpinnerService.start('mainSpinner');

        if (!vm.mainGroup.attributeVisibility) { vm.mainGroup.attributeVisibility = {}; }
        vm.mainGroup.attributeVisibility.intrastat = vm.attributeVisibility.intrastat.value;
        vm.mainGroup.attributeVisibility.meursing = vm.attributeVisibility.meursing.value;
        vm.mainGroup.attributeVisibility.productHeight = vm.attributeVisibility.productHeight.value;
        vm.mainGroup.attributeVisibility.productLength = vm.attributeVisibility.productLength.value;
        vm.mainGroup.attributeVisibility.productWeight = vm.attributeVisibility.productWeight.value;
        vm.mainGroup.attributeVisibility.productWidth = vm.attributeVisibility.productWidth.value;
        vm.mainGroup.attributeVisibility.storageLocation = vm.attributeVisibility.storageLocation.value;

        MaingroupsApiService.createMainGroup({mainGroup: vm.mainGroup, brands: vm.selectedBrands}).then(function (response) {
            vm.mainGroup = response;
            prepareData();
            vm.selectedBrands = [];
            vm.isNewMainGroup = false;
            vm.isEditing = false;
            $state.go('product.maingroups.maingroup', { mainGroupId: response.id });
        }, function (error) {
            console.log(error);
        }).then(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updateMainGroup() {
        loadSpinnerService.start('mainSpinner');

        vm.mainGroup.attributeVisibility.intrastat = vm.attributeVisibility.intrastat.value;
        vm.mainGroup.attributeVisibility.meursing = vm.attributeVisibility.meursing.value;
        vm.mainGroup.attributeVisibility.productHeight = vm.attributeVisibility.productHeight.value;
        vm.mainGroup.attributeVisibility.productLength = vm.attributeVisibility.productLength.value;
        vm.mainGroup.attributeVisibility.productWeight = vm.attributeVisibility.productWeight.value;
        vm.mainGroup.attributeVisibility.productWidth = vm.attributeVisibility.productWidth.value;
        vm.mainGroup.attributeVisibility.storageLocation = vm.attributeVisibility.storageLocation.value;

        MaingroupsApiService.updateMainGroup({mainGroup: vm.mainGroup, brands: vm.selectedBrands}).then(function (response) {
            vm.mainGroup = response;
            prepareData();
            vm.selectedBrands = [];
            vm.isEditing = false;
        }, function (error) {
            console.log(error);
        }).then(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function prepareData() {
        if (vm.mainGroup === undefined) {
            return;
        }

        // Filter out brands that are already added.
        var tempBrands = [];
        _.forEach(brands, function (brand) {
            if (!_.find(vm.mainGroup.itemGroups, function (itemGroup) {
                return itemGroup.brand.id === brand.id;
            })) {
                tempBrands.push(brand);
            }
        });

        vm.brands = _.sortBy(tempBrands, function (brand) {
            return brand.brandCode;
        });

        vm.mainGroup.brands = _.sortBy(vm.mainGroup.brands, function (brand) {
            return brand.brandCode;
        });
    }

    function isAllInformationValid() {
        return (
            !vm.isNewMainGroup &&
            isMainGroupDescriptionValid()&&
            isMainGroupVatValid()
        ) || (
            isMainGroupCodeValid()
        );
   }

    function isMainGroupVatValid() {
        if (vm.mainGroup.vat && vm.mainGroup.vat.id !== -1 && vm.mainGroup.vat.id !== undefined) {
            return true;
        }
        return  false;
    }

    function isMainGroupCodeValid() {
        var isMainGroupCodeAlreadyAssigned = _.find(vm.tenantConfig.assignedMainGroupCodes, function (code) {
            return vm.mainGroup.mainGroupCode === code;
        });

        if (!isMainGroupCodeAlreadyAssigned && isNumeric(vm.mainGroup.mainGroupCode) && vm.mainGroup.mainGroupCode.length === vm.tenantConfig.articleMainGroupCodeLength) {
            return true;
        } else {
            return false;
        }
    }

    function isMainGroupDescriptionValid() {
        return vm.mainGroup.mainGroupDescription && vm.mainGroup.mainGroupDescription.length > 0;
    }

    function isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

}

angular
    .module('maingroups.maingroup', [])
    .config(stateConfig)
    .controller('MainGroupController', MainGroupController);
